// Translations dictionary. Keys are language-neutral identifiers.
// Use t(key) via useTranslation() to read the current language's value.

export const SUPPORTED_LANGUAGES = ["fr", "de"];
export const DEFAULT_LANGUAGE = "fr";

export const translations = {
  // ====== App shell / menus ======
  "menu.back": { fr: "Retour", de: "Zurück" },
  "menu.language": { fr: "Langue", de: "Sprache" },

  // ====== Homescreen ======
  "home.patientInfo": { fr: "Information Patient", de: "Patienteninformation" },
  "home.newPatient": { fr: "Nouveau patient", de: "Neuer Patient" },
  "home.nom": { fr: "Nom", de: "Name" },
  "home.prenom": { fr: "Prénom", de: "Vorname" },
  "home.dateNaissance": { fr: "Date de naissance", de: "Geburtsdatum" },
  "home.age": { fr: "Âge", de: "Alter" },
  "home.years": { fr: "ans", de: "Jahre" },
  "home.dateExamen": { fr: "Date de l'examen", de: "Datum der Untersuchung" },
  "home.dateExamenComparatif1": {
    fr: "Date de l'examen (comparatif 1)",
    de: "Datum der Untersuchung (vergleichend 1)",
  },
  "home.dateExamenComparatif2": {
    fr: "Date de l'examen (comparatif 2)",
    de: "Datum der Untersuchung (vergleichend 2)",
  },
  "home.lateralite": { fr: "Latéralité", de: "Händigkeit" },
  "home.lateralite.D": { fr: "D (Droitier)", de: "R (Rechtshänder)" },
  "home.lateralite.G": { fr: "G (Gaucher)", de: "L (Linkshänder)" },
  "home.lateralite.A": { fr: "A (Ambidextre)", de: "B (Beidhändig)" },
  "home.genre": { fr: "Genre", de: "Geschlecht" },
  "home.genre.H": { fr: "H (Homme)", de: "M (Mann)" },
  "home.genre.F": { fr: "F (Femme)", de: "W (Frau)" },
  "home.niveau": { fr: "Niveau", de: "Niveau" },
  "home.langueMaternelle": {
    fr: "Langue maternelle (langue d'examen)",
    de: "Muttersprache (Untersuchungssprache)",
  },
  "home.anneesEtudes": { fr: "Années d'études", de: "Anzahl Ausbildungsjahre" },
  "home.profile": { fr: "Profil du patient", de: "Patientenprofil" },
  "home.tests": { fr: "Tests", de: "Tests" },
  "home.profileLangMismatch": {
    fr: "Profil DE — la langue actuelle est FR",
    de: "FR-Profil — die aktuelle Sprache ist DE",
  },
  "home.dropGeria": {
    fr: "Déposer le fichier GERIA-12 XLS",
    de: "GERIA-12 XLS-Datei hier ablegen",
  },
  "home.geria.success": {
    fr: "GERIA-12 importé ({file}) — {count} tests mis à jour",
    de: "GERIA-12 importiert ({file}) — {count} Tests aktualisiert",
  },
  "home.geria.dropTypeError": {
    fr: "Veuillez déposer un fichier .xls ou .xlsx",
    de: "Bitte eine .xls- oder .xlsx-Datei ablegen",
  },
  "home.geria.readError": {
    fr: "Erreur lors de la lecture du fichier",
    de: "Fehler beim Lesen der Datei",
  },

  // ====== Profile dialog ======
  "profile.new": { fr: "Nouveau profil", de: "Neues Profil" },
  "profile.edit": { fr: "Modifier le profil", de: "Profil bearbeiten" },
  "profile.name": { fr: "Nom du profil", de: "Profilname" },
  "profile.tests": { fr: "Tests inclus", de: "Inkludierte Tests" },
  "profile.useTemplate": { fr: "Utiliser un profil existant comme modèle", de: "Vorhandenes Profil als Vorlage verwenden" },
  "profile.noTemplate": { fr: "Aucun", de: "Keine" },
  "profile.save": { fr: "Enregistrer", de: "Speichern" },
  "profile.cancel": { fr: "Annuler", de: "Abbrechen" },
  "profile.delete": { fr: "Supprimer", de: "Löschen" },
  "profile.confirmDelete": {
    fr: "Voulez-vous vraiment supprimer ce profil ?",
    de: "Möchten Sie dieses Profil wirklich löschen?",
  },

  // ====== NewScoreSheet ======
  "score.title": { fr: "Tests Profil Patient", de: "Tests Patientenprofil" },
  "score.dragging": { fr: "Déposer les fichiers ici", de: "Dateien hier ablegen" },
  "score.dragHint": {
    fr: "Glisser-déposer tous les fichiers RTF (TAP, TAP-M...) et XLS (CERAD, GERIA-12, NOSGER, BDQ) pour remplissage automatique",
    de: "RTF-Dateien (TAP, TAP-M…) und XLS-Dateien (CERAD, GERIA-12, NOSGER, BDQ) hier ablegen für automatisches Ausfüllen",
  },
  "score.analyzing": { fr: "Analyse des fichiers...", de: "Dateien werden analysiert..." },
  "score.fill": { fr: "Remplir les scores", de: "Ergebnisse eintragen" },
  "score.processing": { fr: "Processing...", de: "Verarbeitung..." },
  "score.saved": { fr: "Fichier enregistré", de: "Datei gespeichert" },
  "score.error": { fr: "Erreur", de: "Fehler" },
  "score.notInProfile": { fr: "pas dans le profil", de: "nicht im Profil" },
  "score.uploadError": { fr: "erreur", de: "Fehler" },
  "score.noZ": { fr: "Aucun z-score valide", de: "Kein gültiger z-Wert gefunden" },
  "score.skippedNoDE": {
    fr: "{count} test(s) ignoré(s) (pas de correspondance DE)",
    de: "{count} Test(s) übersprungen (keine DE-Entsprechung)",
  },

  // ====== Sections ======
  "section.attention": { fr: "Attention", de: "Aufmerksamkeit" },
  "section.executive": { fr: "Fonctions exécutives", de: "Exekutivfunktionen" },
  "section.orientation": { fr: "Orientation", de: "Orientierung" },
  "section.verbalMemory": { fr: "Mémoire verbale", de: "Verbales Gedächtnis" },
  "section.visualMemory": { fr: "Mémoire visuelle", de: "Visuelles Gedächtnis" },
  "section.visuospatial": {
    fr: "Traitement visuo-spatial et praxies constructives",
    de: "Visuell-räumliche und visuokonstruktive Leistungen",
  },
  "section.praxies": { fr: "Praxies gestuelles", de: "Praxien" },
  "section.language": { fr: "Langage oral et écrit", de: "Sprachleistungen" },
  "section.calcul": { fr: "Calcul", de: "Rechenleistungen" },
  "section.cognitiveGlobal": {
    fr: "Performances intellectuelles générales",
    de: "Allgemeine kognitive Leistungsfähigkeit",
  },
  "section.questionnaires": { fr: "Questionnaires", de: "Fragebögen" },
  "section.other": { fr: "Autres", de: "Andere" },

  // ====== Common UI ======
  "common.ok": { fr: "OK", de: "OK" },
  "common.cancel": { fr: "Annuler", de: "Abbrechen" },
  "common.save": { fr: "Enregistrer", de: "Speichern" },
  "common.delete": { fr: "Supprimer", de: "Löschen" },
  "common.edit": { fr: "Modifier", de: "Bearbeiten" },
  "common.add": { fr: "Ajouter", de: "Hinzufügen" },
  "common.close": { fr: "Fermer", de: "Schliessen" },
  "common.comment": { fr: "Commentaire", de: "Kommentar" },
  "common.commentShort": { fr: "comment", de: "Kommentar" },
  "common.upload": { fr: "Uploader", de: "Hochladen" },
  "common.uploadRTF": { fr: "Importer RTF", de: "RTF importieren" },
  "common.required": { fr: "obligatoire", de: "erforderlich" },
  "common.missing": { fr: "variables manquantes", de: "fehlende Variablen" },
  "common.score": { fr: "Score", de: "Punktzahl" },
  "common.result": { fr: "Résultat", de: "Ergebnis" },
  "common.notSignificant": { fr: "non significatif", de: "nicht signifikant" },
  "common.significant": { fr: "significatif", de: "signifikant" },

  // ====== RTF dialog ======
  "rtf.title": { fr: "Importer fichier RTF", de: "RTF-Datei importieren" },
  "rtf.dragDrop": {
    fr: "Glisser-déposer un fichier RTF ici",
    de: "RTF-Datei hier ablegen",
  },
  "rtf.orBrowse": { fr: "ou cliquer pour parcourir", de: "oder klicken zum Auswählen" },
  "rtf.parsing": { fr: "Analyse...", de: "Analyse..." },
  "rtf.error": { fr: "Erreur lors de l'analyse", de: "Fehler bei der Analyse" },
  "rtf.openFile": { fr: "Ouvrir un fichier", de: "Datei öffnen" },

  // ====== TestCard inputs / errors ======
  "test.upload": { fr: "Uploader RTF", de: "RTF hochladen" },
  "test.deficit": { fr: "déficitaire", de: "defizitär" },
  "test.nonDeficit": { fr: "non déficitaire", de: "nicht defizitär" },
  "test.significative": { fr: "significative", de: "signifikant" },
  "test.pasSignificative": { fr: "pas significative", de: "nicht signifikant" },
  "test.indep": { fr: "Indépendant", de: "Selbstständig" },
  "test.ems": { fr: "EMS", de: "Heim" },
  "test.deviationLeft": { fr: "Gauche", de: "Links" },
  "test.deviationRight": { fr: "Droite", de: "Rechts" },
  "test.deviationMean": { fr: "Déviation moy.", de: "Mittlere Abweichung" },
  "test.direction": { fr: "Direction", de: "Richtung" },
  "test.errorYears": {
    fr: "Veuillez entrer les années d'études",
    de: "Bitte Anzahl Ausbildungsjahre eingeben",
  },
  "test.errorAgeRange": {
    fr: "âge hors normes (50–80)",
    de: "Alter ausserhalb der Normen (50–80)",
  },
  "test.errorImmediate": {
    fr: "Veuillez entrer le score de rappel immédiat",
    de: "Bitte unmittelbaren Abruf eingeben",
  },
  "test.errorDelayed": {
    fr: "Veuillez entrer le score de rappel différé",
    de: "Bitte verzögerten Abruf eingeben",
  },
  "test.errorNoZ": {
    fr: "Aucun z-score valide trouvé dans le fichier",
    de: "Keine gültigen z-Werte in der Datei gefunden",
  },
  "test.errorMissing": { fr: "variables manquantes", de: "fehlende Variablen" },
  "test.clinicalNote": { fr: "Note clinique", de: "Klinische Notiz" },
  "test.reset": { fr: "Réinitialiser ce test", de: "Diesen Test zurücksetzen" },
  "test.resetConfirm": {
    fr: "Effacer toutes les valeurs saisies pour ce test ?",
    de: "Alle eingegebenen Werte für diesen Test löschen?",
  },

  // ====== Score level / qualitative labels ======
  "level.somnNoSig": { fr: "non significatif", de: "nicht signifikant" },
  "level.somnSleepDeficit": {
    fr: "score indicateur d'un déficit de sommeil",
    de: "Hinweis auf Schlafdefizit",
  },
  "level.somnExcessive": {
    fr: "score évocateur de somnolence diurne excessive",
    de: "Hinweis auf erhöhte Tagesschläfrigkeit",
  },
};

// Resolve a translated value with optional {placeholder} substitution.
export const interpolate = (str, vars) => {
  if (!str || !vars) return str;
  return str.replace(/\{(\w+)\}/g, (_, k) => (vars[k] != null ? vars[k] : `{${k}}`));
};

// Pick the {fr,de} variant of a polymorphic value (string, object, or array of strings).
export const pickLang = (value, lang) => {
  if (value == null) return value;
  if (typeof value === "string") return value;
  if (Array.isArray(value)) return value;
  if (typeof value === "object" && (value.fr !== undefined || value.de !== undefined)) {
    return value[lang] ?? value.fr ?? value.de ?? "";
  }
  return value;
};
